export default "__VITE_ASSET__DE_do6ji__"